/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Openportalfailed2Inputs */

const zh_billing_openportalfailed2 = /** @type {(inputs: Billing_Openportalfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开账单门户失败`)
};

const en_billing_openportalfailed2 = /** @type {(inputs: Billing_Openportalfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to open billing portal`)
};

const es_billing_openportalfailed2 = /** @type {(inputs: Billing_Openportalfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al abrir el portal de facturación`)
};

/**
* | output |
* | --- |
* | "Failed to open billing portal" |
*
* @param {Billing_Openportalfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_openportalfailed2 = /** @type {((inputs?: Billing_Openportalfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Openportalfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_openportalfailed2(inputs)
	if (locale === "en") return en_billing_openportalfailed2(inputs)
	return es_billing_openportalfailed2(inputs)
});
export { billing_openportalfailed2 as "billing_openPortalFailed" }